<template>
  <TableGradient
      icon-name="cubes"
      :title="$t('result_conversion.index.listagem_conversao_resultado')"
      :text-empty="$t('result_conversion.index.conversao_resultado_nao_encontrada')"
      table-data
      route-new="resultconversion.create"
      :text-new="$t('result_conversion.index.criar_conversao_resultado')"
      :fields="fields"
      :fields-filter="filter"
      :items="resultconversions"
      :loading="isLoading"
      :paginator="paginator"
      @list="evt => $store.dispatch('dexpara/resultconversion/listAllPaginated', evt)">
    <template v-slot:cell(mapping_result_conversion_status)="linha">
      <span
          :class="{'rounded-pill p-1 ':true, 'badge badge-success':linha.item.mapping_result_conversion_status, 'badge badge-danger': !linha.item.mapping_result_conversion_status}">
          <i :class="linha.item.mapping_result_conversion_status ? 'fas fa-check' : 'fas fa-ban'"/>
      </span>
    </template>
    <template v-slot:cell(id)="{index, item}">
      <router-link
        :id="`link-edit-${index}`"
        :to="{ name: 'resultconversion.edit', params: { id: item.mapping_result_conversion_id }}"
        class="font-weight-bold"
      >
        {{ $t('result_conversion.index.editar') }}
      </router-link>
    </template>
  </TableGradient>
</template>

<script>
import TableGradient from "@/templates/TableGradient";
import TableSimple from "@/components/TableSimple";
import {mapActions, mapGetters, mapMutations} from 'vuex';

export default {
  name: "Index",
  components: {TableGradient, TableSimple},
  computed: {
    ...mapGetters({
      resultconversions: 'dexpara/resultconversion/all',
      store_isLoading: 'dexpara/resultconversion/isLoading',
      paginator: 'dexpara/resultconversion/pagination'
    }),
    isLoading() {
      return !(this.mounted && this.store_isLoading === false)
    }
  },
  data() {
    return {
      mounted: false,
      fields: [        
        {key: 'vns_integration_origin_name', label: this.$t('result_conversion.index.origem'), sortable: true},
        {key: 'vns_integration_destination_name', label: this.$t('result_conversion.index.destino'), sortable: true},
        {key: 'tuevs_exam_name', label: this.$t('result_conversion.index.exame'), sortable: true},
        {key: 'mapping_result_conversion_status', label: 'Status', sortable: true},
        {key: 'id', label: this.$t('result_conversion.index.editar')},
      ],
      filter: [
        {key: 'origin.name', label: this.$t('result_conversion.index.origem')},
        {key: 'destination.name', label: this.$t('result_conversion.index.destino')},
        {key: 'tuevs_exams.name', label: this.$t('result_conversion.index.exame')},
      ],
    }
  },
  methods: {
    ...mapActions([
      'dexpara/resultconversion/listAllPaginated'
    ]),
    ...mapMutations([
      'resultconversion/setAll'
    ])    
  },
  async mounted() {
    await this['dexpara/resultconversion/listAllPaginated'](this.paginator)
    this.mounted = true
  }
}
</script>
